<template>
  <div style="width:100%;height: 100%;">
    <div id="container" style="width:100%;height: 100%;"></div>
    <div class="input-card">
      <div class="input-item">
        <el-button  type="primary" :icon="Share" id="start" @click="startDrawPolygon()" v-if="polygonList.length<=0">开始绘制</el-button>
        <el-button  type="primary" :icon="Share" id="start" disabled v-else>开始绘制</el-button>
      </div>
      <div class="input-item" >
        <el-button  type="warning" :icon="RefreshLeft" id="pause" @click="changeSearchValue(this.searchValue)" v-if="polygonList.length>0" >重置</el-button>
        <el-button  type="warning" :icon="RefreshLeft" id="pause"  v-else disabled>重置</el-button>
      </div>
      <div class="input-item">
        <el-button  type="primary" :icon="DocumentChecked" id="resume" @click="stopAndSave()" v-if="polygonList.length>0 " >确定并退出</el-button>
        <el-button  type="primary" :icon="DocumentChecked" id="resume"  v-else disabled >保存并退出</el-button>
      </div>
      <div class="input-item" style="display:none" >
        <el-button  type="primary" :icon="RefreshLeft" id="stop" @click="redrawPolygon()" >重新绘制</el-button>
      </div>
    </div>
    <div class="search-address">
        <el-input
          v-model="searchValue"
          class="w-50 m-2"
          placeholder="请输入地名"
          :suffix-icon="Location"
          @change="changeSearchValue"
          clearable 
        />
    </div>
  </div>
</template>

<script>
import { Share,DeleteLocation,RefreshLeft,DocumentChecked,Location} from '@element-plus/icons-vue'
import { defineComponent } from "vue";
export default defineComponent({
  data(){
    return {
      Share,DeleteLocation,RefreshLeft,DocumentChecked,Location,

      searchValue:'',

      map: null,
      mouseTool: null,
      polyType: {
        strokeColor: "#E47878",
        strokeOpacity: 1,
        strokeWeight: 4,
        strokeOpacity: 0.2,
        fillColor: "#1791fc",
        fillOpacity: 0.4,
        // 线样式还支持 'dashed'
        strokeStyle: "solid"
        // strokeStyle是dashed时有效
        // strokeDasharray: [30,10],
      },
      polygonList: [],
      savedPolygon: []
    }
  },
  props: {
    //电子围栏信息参数
    electronicFence: String,
    drawComplete: Function,  // 绘制完成回调
  },
  created() { },
  mounted() {
    this.$nextTick(() => {
      this.initMap();
    });
    
    
  },
  methods: {
     //清除绘制的围栏
    clearPolygon() {
      this.polygonList = [];
      this.map.clearMap(); // 清除地图上的所有覆盖物
    },

    initMap() {
      let that = this
      let citysearch = new AMap.CitySearch();
      //  获取用户IP，返回当前城市
      citysearch.getLocalCity(function (status, result) {
        if (status === 'complete' && result.info === 'OK') {
          if (result && result.city && result.bounds) {
            let cityInfo = result.city;
            that.markLocation(cityInfo);
          }
        } else {
          alert(result.info)
        }
      })
    },
    markLocation(address) {
      if(!address){
        return false;
      }
      let that = this
      AMap.plugin('AMap.Geocoder', function () {
        var geocoder = new AMap.Geocoder();
        geocoder.getLocation(address, function (status, result) {
          if (status === 'complete' && result.info === 'OK') {
            // 经纬度                      
            var lng = result.geocodes[0].location.lng;
            var lat = result.geocodes[0].location.lat;
            // 地图实例
            that.map = new AMap.Map("container", {
              resizeEnable: true, // 允许缩放
              center: [lng, lat], // 设置地图的中心点
              zoom: 15 // 设置地图的缩放级别，0 - 20
            });
            that.redrawPolygon();
          } else {
            console.log('定位失败！');
          }
        });
        
      });
      
    },
    
    //查询定位地点
    changeSearchValue(val){
      if(val){
        this.markLocation(val);
      }else{
        this.initMap();
      }
    },

    //点击开始绘制
    startDrawPolygon() {
      this.clearPolygon();
      let that = this;
      that.map.plugin("AMap.MouseTool", function() {
        that.mouseTool = new AMap.MouseTool(that.map);
      });
      that.mouseTool.polygon(this.polyType);
      
      //监听draw事件可获取画好的覆盖物
      that.polygonList = [];
      that.mouseTool.on("draw", function(e) {
        that.polygonList.push(e.obj);
        console.log("绘制的多边形", that.polygonList);
        that.mouseTool.close();
      });
    },
    //结束并保存
    stopAndSave() {
      // this.mouseTool.close();
      let savedPolygon = [];
      if(this.polygonList && this.polygonList.length>0){
        for (let i = 0; i < this.polygonList.length; i++) {
        console.log(this.polygonList[i].getOptions());
        let op = this.polygonList[i].getOptions();
        let routePath = [];
        op.path.forEach(item => {
          //routePath.push([item.lng, item.lat]);
          routePath.push([item[0], item[1]]);
        });
        let savearr = {
          path: routePath,
          strokeColor: op.strokeColor,
          strokeOpacity: op.strokeOpacity,
          fillOpacity: op.fillOpacity,
          fillColor: op.fillColor,
          zIndex: op.zIndex
        };
        savedPolygon.push(savearr);
      }
      let save = JSON.stringify(savedPolygon);
      //存取
      this.drawComplete(save);
      }
    },
   
    // 用保存的数据重新绘制多边形并添加事件
    redrawPolygon() {
      this.clearPolygon();
      if(this.electronicFence){
        let savedPolygon = JSON.parse(this.electronicFence);
        console.log("重绘多边形数据", savedPolygon);
        if (savedPolygon == null) return;
        for (let i = 0; i < savedPolygon.length; i++) {
          var polygon = new AMap.Polygon(savedPolygon[i]);
          this.map.add(polygon);
        }
      }
    },

  }
})
</script>
<style lang="scss" scoped>
  .input-card{
    display: flex;
    position: absolute;
    top: 45px;
    left: 10px;
    padding: 10px;
    background: white;
    box-shadow: 2px 2px 5px #7a7a7a;
    width: 355px;
    justify-content: space-between;
  }
  .search-address{
    display: flex;
    position: absolute;
    top: 45px;
    left: 395px;
    padding: 10px;
    background: white;
    box-shadow: 2px 2px 5px #7a7a7a;
    width: 315px;
    justify-content: space-between;
  }
</style>